<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal")
                v-icon(color="basic800" :size="24") mdi-close
            v-col.ml-3
              p.mb-0.h6.basic800--text Products for item {{ slotNumber }}

        v-card-text.pa-0
          div.px-2.py-4.d-flex
            v-btn(text small @click="openAssignProductsBundleDialog = true")
              v-icon.mr-2 mdi-plus
              .button-Aa-medium.primary500--text Add product
            v-spacer
            v-btn(outlined small @click="openArrangeProductsBundleDialog = true" :style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
              .button-AA-tiny.primary500--text Rearrange

          //- v-container.white(style="max-width:600px")
          //-   v-layout.mt-2
          //-     v-text-field(v-model="searchText" placeholder='Search product' hide-details dense outlined height="40" background-color="basic200")
          //-       template(v-slot:append)
          //-         eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
          
          v-container.px-1.py-0(style="max-width:600px")
            v-layout.my-6(v-if="isFetching")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            .contain-layout(v-else)
              v-layout.my-6(v-if="productNotFound")
                v-row.fill-height.ma-0(align='center' justify='center')
                  div.mx-auto
                    v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                    p.caption Products not found or empty
              div(v-else)
                template(v-for="(product, productIndex) in products")
                  v-card(v-if="product.view" flat)
                    v-row(no-gutters )
                      v-col.shrink
                        v-img(:src="product.image ? product.image.file : require('@/assets/image_placeholder.png')" width="88px" aspect-ratio="1")
                      v-col.py-2.px-2
                        div.p1.basic800--text.mb-1(v-if="$vuetify.breakpoint.xs") {{ product.name | truncate(27) }}
                        div.p1.basic800--text.mb-1(v-else) {{ product.name | truncate(65) }}
                        div.c1.basic600--text.product-price.mb-1 {{ product.price | displayPrice }}
                        v-chip.c2.primary500--text.my-auto(v-if="product.options.length > 0" x-small style="border: 1px solid var(--v-primary500)") {{ product.options.length === 1 ? 'Variants' : 'Multivariants' }}
                      v-col.shrink.d-flex.flex-column.align-center
                        v-btn.mr-4.mb-2(icon @click="removeProduct(productIndex)" :disabled="products.length === 1")
                          eva-icon(name="trash-outline" :fill="products.length === 1 ? $vuetify.theme.themes[$theme].basic500 : $vuetify.theme.themes[$theme].basic700" width="16" height="16")
                        v-btn.mr-4(v-if="product.options.length > 0" icon @click.stop="product.showSpecsGroup = !product.showSpecsGroup")
                          eva-icon(:name="product.showSpecsGroup ? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline'" width="16" height="16" :fill="$vuetify.theme.themes[$theme].primary500")
                  template(v-if="product.options.length > 0 && product.showSpecsGroup")
                    v-divider.basic300.mb-4
                    div.pb-4.px-6(v-for="(parentSpec, parentSpecIndex) in product.specsGroup" :key="parentSpec.id")
                      div.clickable(@click="changeParentSelection(parentSpec, product.specsGroup)")
                        y-checkbox(v-model="parentSpec.selected" readonly)
                          template(v-slot:label)
                            div.p2 {{ parentSpec.value }}
                      template(v-if="parentSpec.child")
                        v-row.pl-6(no-gutters)
                          v-col.my-1(v-for="childSpec in parentSpec.child" :key="childSpec.id" cols="6")
                            div.clickable(@click="changeChildSelection(childSpec, parentSpec.child, parentSpec, product.specsGroup)")
                              y-checkbox(v-model="childSpec.selected" readonly)
                                template(v-slot:label)
                                  div.p2 {{ childSpec.value }}
                        v-divider.basic300.my-2(v-if="parentSpec.child && parentSpecIndex < product.specsGroup.length - 1")

                  v-divider.basic300
        //- Actions
        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text Cancel
          v-btn.mr-2(color='textColorAccent' depressed height=32  @click="clickDone" :loading="isLoading" dark)
            .button-AA-small.basic100--text Done
    .dialogs
      assign-products-bundle(v-if="openAssignProductsBundleDialog" :open.sync="openAssignProductsBundleDialog" :excludeProductIds="excludeProductIds" @updateData="handleAddProducts")
      arrange-products-bundle(v-if="openArrangeProductsBundleDialog" :open.sync="openArrangeProductsBundleDialog" :parentProducts="products" :slotNumber="slotNumber" @updateData="handleArrangedProducts")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import clone from 'just-clone';
import AssignProductsBundle from '@/components/offers/dialogs/bundles/AssignProductsBundle.vue'
import ArrangeProductsBundle from '@/components/offers/dialogs/bundles/ArrangeProductsBundle.vue'

export default {
  name: 'EditProductsBundle',
  components: {
    AssignProductsBundle,
    ArrangeProductsBundle
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    parentSlot: {
      type: Object,
      required: true
    },
    slotNumber: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    products: [],
    searchText: '',
    isLoading: false,
    isFetching: false,
    openAssignProductsBundleDialog: false,
    openArrangeProductsBundleDialog: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    productNotFound() {
      return this.products.filter(product => product.view).length === 0
    },
    excludeProductIds() {
      return this.products.map(product => product.id).join(',')
    }
  },
  watch: {
    searchText(val) {
      this.products.forEach(product => {
        // Handle empty value
        if (val === '') {
          product.view = true
          return
        }
        // Filtering
        const lowerCaseSearch = val.toLowerCase()
        const lowerCaseName = product.name.toLowerCase()
        product.view = lowerCaseName.includes(lowerCaseSearch)
      })
    }
  },
  mounted() {
    this.processProducts()
  },
  methods: {
    ...mapActions(['showMessage']),
    changeChildSelection(childSpec, childrenGroup, parentSpec, parentGroup) {
      const currentState = childSpec.selected
      // Find 2 or more others left, then ok!
      const hasOtherChildrenLeft = childrenGroup.filter(spec => spec.selected).length > 1
      // Check to prevent selection if no other parentspec left
      if (currentState && !hasOtherChildrenLeft) {
        // Find 2 or more others left, then ok!
        const hasOthersLeft = parentGroup.filter(spec => spec.selected).length > 1
        if (!hasOthersLeft) {
          this.showMessage(['error', this.$t('error_message.delete_product_remove_variants')])
          return
        }
      }
      // Change state
      const nextState = !currentState
      childSpec.selected = nextState
      const hasOneChildSelected = childrenGroup.some(item => item.selected)
      parentSpec.selected = hasOneChildSelected
    },
    changeParentSelection(parentSpec, parentGroup) {
      const currentState = parentSpec.selected
      // Check to prevent selection if no other parentspec left
      if (currentState) {
        // Find 2 or more others left, then ok!
        const hasOthersLeft = parentGroup.filter(spec => spec.selected).length > 1
        if (!hasOthersLeft) {
          this.showMessage(['error', this.$t('error_message.delete_product_remove_variants')])
          return
        }
      }
      // Change state
      const nextState = !currentState
      parentSpec.selected = nextState
      // Propagate to child if any
      if (parentSpec.child) {
        parentSpec.child.forEach(item => (item.selected = nextState))
      }
    },
    getSelected(specIds = [], enabledVariants = []) {
      let selected = false
      if (specIds.length > 1) {
        enabledVariants.forEach(variant => {
          if (variant.specs.every(variantSpec => specIds.includes(variantSpec))) {
            selected = true
          }
        })
      } else {
        enabledVariants.forEach(variant => {
          if (variant.specs.includes(specIds[0])) {
            selected = true
          }
        })
      }
      return selected
    },
    filterProperties(obj) {
      const allowedProperties = ['id', 'status', 'name', 'price', 'image', 'options', 'variants']
      const filteredObj = this.$options.filters.filterAllowedObjectProperties(obj, allowedProperties)
      // Custom properties
      filteredObj.view = true
      if (filteredObj.options.length > 0) {
        filteredObj.specsGroup = this.productSpecGrouping(
          filteredObj.options,
          filteredObj.variants.filter(variant => variant.enabled)
        )
        filteredObj.showSpecsGroup = false
      }

      return filteredObj
    },
    processProducts() {
      this.products = this.parentSlot.group.products.map(product => {
        return this.filterProperties(product)
      })
    },
    handleAddProducts(newValue) {
      const processedData = newValue.map(value => {
        return this.filterProperties(value)
      })
      this.products = this.products.concat(processedData)
    },
    handleArrangedProducts(newValue) {
      this.products = clone(newValue)
    },
    productSpecGrouping(options, enabledVariants) {
      /** Data Preparation
       * Must be in form of array of array
       * Example
       * [
       *  [
       *    { id: 1, value: 'Black'},
       *    { id: null, value: 'White'}
       *  ],
       *  [
       *    { id: 2, value: 'L' },
       *    { id: 3, value: 'M' },
       *    { id: null, value: 'S'}
       * ], ...]
       *  **/
      const data = []
      options.forEach(option => {
        data.push(
          option.specs.map(spec => {
            return {
              id: spec.id,
              value: spec.value
            }
          })
        )
      })
      const that = this
      // Grouping process
      function assignChildren(parentGroup, childGroup) {
        parentGroup.forEach(parent => {
          if (!parent.child) {
            // Create child for prev group
            const newData = childGroup.map(item => {
              return {
                id: item.id,
                value: item.value,
                selected: that.getSelected([parent.id, item.id], enabledVariants),
                child: null
              }
            })

            parent.child = [...newData]
          } else {
            assignChildren(parent.child, childGroup)
          }
        })
      }
      return data.reduce((acc, group) => {
        // Create first group
        if (acc.length === 0) {
          group.forEach(item => {
            acc.push({
              id: item.id,
              value: item.value,
              selected: that.getSelected([item.id], enabledVariants),
              child: null
            })
          })
        } else {
          // Assign nested childrens
          assignChildren(acc, group)
        }
        return acc
      }, [])
    },
    removeProduct(productIndex) {
      this.products.splice(productIndex, 1)
    },
    findMatchingVariants({ variants, specs }) {
      /**
       * Construct array of selected specs
       * Example of selected specs
       * White: 1 & XL: 2,
       * White: 1 & L: 3,
       * Black: 2 & XL: 2
       * Return resp will be like this (in sorted order)
       * [[1, 2], [1, 3], [2, 2]]
       */
      function groupSpecs(acc, spec, parentIds) {
        if (spec.selected) {
          if (!spec.child) {
            if (parentIds) {
              acc.push([...parentIds, spec.id].sort())
            } else {
              acc.push([spec.id])
            }
          } else {
            let currentIds = null
            if (parentIds) {
              currentIds = [...parentIds, spec.id]
            } else {
              currentIds = [spec.id]
            }
            spec.child.forEach(child => groupSpecs(acc, child, currentIds))
          }
        }
        return acc
      }
      // Find matched or not and return variant with enabled true/false
      function isMatched(variant, groupedSpec) {
        // Sort variant specs first
        const variantSpecs = variant.specs.sort()
        // Find and filter each groupedSpec based on variant spec
        const found = variantSpecs.reduce((filteredSpecs, spec) => {
          return filteredSpecs.filter(eachSpecs => {
            let resp = false
            if (eachSpecs.includes(spec)) {
              resp = true
            }
            return resp
          })
        }, groupedSpec)
        if (found.length > 0) {
          return { ...variant, enabled: true }
        } else {
          return { ...variant, enabled: false }
        }
      }
      // Grouping and find matching variants
      const groupedSpec = specs.reduce((acc, spec) => {
        return groupSpecs(acc, spec)
      }, [])

      const resp = variants.map(variant => {
        return isMatched(variant, groupedSpec)
      })
      return resp
    },
    clickDone() {
      this.isLoading = true
      const resp = this.products.map(product => {
        const allowedProperties = ['id', 'name', 'image', 'price', 'options']
        const data = this.$options.filters.filterAllowedObjectProperties(product, allowedProperties)
        if (product.specsGroup) {
          data.variants = this.findMatchingVariants({ variants: product.variants, specs: product.specsGroup })
        } else {
          data.variants = []
        }
        return data
      })
      this.$emit('updateData', resp)
      this.showModal = false
    }
  }
}
</script>

<style scoped>
.product-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>